export const reference = {
  pvq: {
    heading: {
      name: "Provide this person's full name",
      contact: 'Provide date of last contact',
      relationship: 'Relationship',
      phone: {
        default: 'Provide the telephone number for this person',
        evening: "Provide this person's evening phone number",
        day: "Provide this person's daytime phone number",
        mobile: "Provide this person's cell/mobile phone number",
      },
      email: "Provide this person's email address",
      correspondence: 'Their contact information',
      address: 'Provide current address for this person',
      employment: {
        address: 'Provide the address of this verifier',
      },
    },
    para: {
      correspondence: 'Provide the following contact information for this person.',
      address: 'Provide street address for this person (including apartment number).',
      or: 'or',
    },
    label: {
      relationship: {
        title: 'Provide your relationship to this person (check all that apply):',
        neighbor: 'Neighbor',
        friend: 'Friend',
        landlord: 'Landlord',
        business: 'Business associate',
        other: 'Other',
        explanation: 'Please provide an explanation',
      },
      email: 'Provide email address for this person',
      idk: "I don't know",
      idkNa: "I don't know / Not Applicable",
      notApplicable: 'Not Applicable',
      idkNumber: "I don't know / No Number",
      noNumber: "No Number",
      address: 'The address of your contact during this time period',
      employment: {
        address: 'The address of your verifier',
      },
    },
    name: {
      label: {
        first: 'First name',
        last: 'Last name',
        middle: 'Middle name',
        initialOnly: 'Initial only',
        noFirst: 'No first name',
        noMiddle: 'No middle name',
        other: 'Other',
        suffix: 'Suffix',
        optional: 'Optional',
        jr: 'Jr',
        sr: 'Sr',
        i: 'I',
        ii: 'II',
        iii: 'III',
        iv: 'IV',
        v: 'V',
        vi: 'VI',
        vii: 'VII',
        viii: 'VIII',
        ix: 'IX',
        x: 'X',
      },
    },
    help: {
      contact: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      relationship: {
        title: 'Need help defining your relationship?',
        message: 'Please define your relationship with the person during this period.',
        note: '',
      },
      email: {
        title: 'Please use an active email',
        message: 'Make sure this person can be reached at this email address.',
        note: '',
      },
      phone: {
        title: 'Please use an active phone number',
        message: 'Make sure this person can be reached at this number.',
        note: '',
      },
      address: {
        title: 'Acronyms:',
        message: 'APO - Army Post Office, FPO - Fleet Post Office.',
        note: '',
      },
    },
  },
  heading: {
    name: "Provide this person's full name",
    contact: 'Provide date of last contact',
    relationship: 'Relationship',
    phone: {
      default: 'Provide the telephone number for this person',
      evening: "Provide this person's evening phone number",
      day: "Provide this person's daytime phone number",
      mobile: "Provide this person's cell/mobile phone number",
    },
    email: "Provide this person's email address",
    correspondence: 'Their contact information',
    address: 'Provide current address for this person',
    employment: {
      address: 'Provide the address of this verifier',
    },
  },
  para: {
    correspondence: 'Provide the following contact information for this person.',
    address: 'Provide street address for this person (including apartment number).',
    or: 'or',
  },
  label: {
    relationship: {
      title: 'Provide your relationship to this person (check all that apply):',
      neighbor: 'Neighbor',
      friend: 'Friend',
      landlord: 'Landlord',
      business: 'Business associate',
      other: 'Other',
      explanation: 'Please provide an explanation',
    },
    email: 'Provide email address for this person',
    idk: "I don't know",
    idkNa: "I don't know / Not Applicable",
    address: 'The address of your contact during this time period',
    employment: {
      address: 'The address of your verifier',
    },
  },
  name: {
    label: {
      first: 'First name',
      last: 'Last name',
      middle: 'Middle name',
      initialOnly: 'Initial only',
      noFirst: 'No first name',
      noMiddle: 'No middle name',
      other: 'Other',
      suffix: 'Suffix',
      optional: 'Optional',
      jr: 'Jr',
      sr: 'Sr',
      i: 'I',
      ii: 'II',
      iii: 'III',
      iv: 'IV',
      v: 'V',
      vi: 'VI',
      vii: 'VII',
      viii: 'VIII',
      ix: 'IX',
      x: 'X',
    },
  },
  help: {
    contact: {
      title: 'Estimate the date if unsure',
      message:
        'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
      note: '',
    },
    relationship: {
      title: 'Need help defining your relationship?',
      message: 'Please define your relationship with the person during this period.',
      note: '',
    },
    email: {
      title: 'Please use an active email',
      message: 'Make sure this person can be reached at this email address.',
      note: '',
    },
    phone: {
      title: 'Please use an active phone number',
      message: 'Make sure this person can be reached at this number.',
      note: '',
    },
    address: {
      title: 'Acronyms:',
      message: 'APO - Army Post Office, FPO - Fleet Post Office.',
      note: '',
    },
  },
};
